import { Text } from "@amzn/meridian";
import Message from "@amzn/meridian/message";
import chatIcon from "src/images/safer_chat_icon.png";
import BotMessage, { BotMessageProps } from "../botMessage/botMessage";

interface DenyConfirmationMessageProps extends BotMessageProps {}
const DenyConfirmationMessage = (props: DenyConfirmationMessageProps) => {
  return (
    <BotMessage {...props}>
      <Text type="b400">Let's try to get you a better answer, you can</Text>
      <Text type="b400" tag="ul">
        <li>Be more specific with your question</li>
        <li>Include relevant context or details</li>
        <li>Rephrase your question in a different way</li>
      </Text>
    </BotMessage>
  );
};

export default DenyConfirmationMessage;
